module.exports = __webpack_public_path__ + "img/40_69_004_920.d49173c3.jpg";